import { boolean } from 'yup/lib/locale';
import { routes } from '../config/routes';
import { EXPLORE_SCHEMES_USER_FLOW } from './ExplorePage';

export const RISK_MESSAGE = 'Moderately High Risk';
export const GROWTH = 'Growth';
export const DIVIDEND = 'Dividend';
export const PAYOUT = 'Payout';
export const REINVESTMENT = 'Reinvestment';
export const NAV_AS_Of = 'NAV as of';
export const INVESTMENT_ID = 'Investment ID';
export const FOLIO_NUMBER = 'Folio Number';
export const SIP = 'SIP';
export const SYSTEMATIC_INVESTMENT = 'Systematic Investment';
export const LUMPSUM = 'Lumpsum';
export const ONE_TIME_INVESTMENT = 'One Time Investment';
export const FREQUENCY = 'Frequency';
export const INVESTMENT_AMOUNT = 'Investment Amount';
export const MINIMUM = 'Minimum';
export const INVESTMENT_TIME_FRAME = 'How long you wish to stay invested';
export const OTHER_INVESTMENT_DETAIL = 'Other Investments details';
export const INVESTMENT_DETAILS = 'Investment Details';
export const MOST_POPULAR = 'MOST POPULAR';
export const IN_YEARS = 'In Years';
export const NUMBER_OF_INSTALLMENT = 'Number of SIPs';
export const UNTIL_CANCELLED = 'Until Cancelled';
export const SIP_DATE = 'Monthly SIP Date';
export const SIP_DATE_NFO = 'SIP Date (Post NFO Allotment)';
export const STARTING_FROM = 'Starting From';
export const LUMPSUMP_CART_MESSAGE =
  '<b>Note :</b> We will be forwarding the transaction details to AMC/RTA for further processing which may take 2-3 working days. Your portfolio will be updated post transaction confirmation from AMC/RTA.';
export const SIP_CART_MESSAGE =
  '<b>Note :</b> For all the SIP transactions executed after cut off timings, the amount will get debited the next business day and transaction details will be forwarded to AMC/RTA for further processing which may take 2-3 working days. Your portfolio will be updated post transaction confirmation from AMC/RTA. Please visit the ‘Past Transactions’ section once the money gets debited.';
export const SIP_MESSAGE =
  '<b>Note :</b> First systematic transaction amount will get debited immediately if order is placed before transaction cut off timing or else next working day. The number of systematic transactions selected by you will be over and above this transaction, and will get executed in future as per the chosen dates.';
export const ADD_NOMINEE_FROM_PREVIOUS_INVESTMENT = 'Add nominee from previous investment';
export const NOTE = 'Note';
export const ADD_NOMINEE = '+  Add Nominee';
export const OPTIONAL = '(Optional)';
export const EDIT = 'Edit';
export const EDIT_NOMINEE = 'Edit Nominee';
export const NOMINEE_DETAILS = 'Nominee Details';
export const UPDATE_NOMINEE_DETAILS = 'Update Nominee Details in New Folio';
export const CONTINUE = 'Continue';
export const GUARDIAN = 'Guardian';
export const MINOR = 'Minor';
export const YES = 'Yes';
export const NO = 'No';
export const CONFIRM = 'Confirm';
// export const INVESTMENT_TIME_FRAME_TOOLTIP_MESSAGE =
//   'Investment Timeframe is amount of time over which you plan to hold an investment. This is different for lock-in period. Investment Timeframe is used to suggest if the purchase you’re making is suitable for you.';
export const INVESTMENT_TIME_FRAME_TOOLTIP_MESSAGE = `Investment timeframe is the period you wish to stay invested. Based on your input, we will alert you if the timeframe is not suitable for your risk profile. Please note that investment timeframe is different from lock-in period of tax saving and other close-ended schemes.`;
// export const NOTE_POINTS = (liquidCutOffTimings: string, othersCutOffTimings: string) => [
//   `The cut-off timings for purchase transactions made through Axis Bank in liquid and overnight schemes is ${liquidCutOffTimings} and other schemes is ${othersCutOffTimings}. Transactions made post cut-off timings will be processed the next business day. The NAV applicability will vary as per the cut-off timings `,
//   'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.',
// ];

export const INVESTMENT_ID_TOOLTIP =
  'Investment ID is a unique account number allotted to investors for executing and tracking their investments done through Axis Bank. Investment ID is unique for every holder combination.';

export const FOLIO_NUMBER_TOOLTIP =
  'Much like a bank account number, a Folio number is your Account Number in a Mutual Fund Scheme, under which your Unit holdings in a mutual fund scheme are recorded in the Unit Holders’ Register.';

export const NOTE_POINTS = (liquidCutOffTimings: string, othersCutOffTimings: string, liquidSwitch: string) => [
  `Please Note that the cut-off timings for transactions made through Axis Bank in liquid and overnight schemes is ${liquidCutOffTimings} and other schemes is ${othersCutOffTimings}. Transactions made post cut-off timings will be processed the next business day. The NAV applicability will vary as per the cut-off timings.`,
  'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.',
];
export const NFO_NOTE_POINTS = (liquidCutOffTimings: string, othersCutOffTimings: string) => [
  'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.',
  'Kindly note cut-off time for investing in NFO through Axis Bank is 5 pm on the last day of the NFO.',
];

export const SIP_NOTE_MESSAGE = [
  'First systematic transaction amount will get debited immediately if order is placed before transaction cut off timing or else next working day. The number of systematic transactions selected by you will be over and above this transaction, and will get executed from next month as per the chosen dates.',
];
export const SIP_NEW_FOLIO_MESSAGE = [
  'For systematic transaction placed on 27th (post cutoff) till last date of the month, subsequent transactions will be triggered from next-to-next month (if Monthly SIP Date is selected from 1st till 5th ) or next month (if Monthly SIP Date is selected post 5th) as per the chosen dates.',
];
export const NEW_NOMINEE_DECLARATION_MESSAGE = (amcName) =>
  `I/We, the above named Unitholders of ${amcName} Mutual Fund, do hereby \n Nominate the person(s) more particularly described hereunder to receive the Units held my/our Folio/s listed below in the event of my / our death.`;
export const NOMINEE_OPTIONAL_CHECKBOX =
  'I/We, want the details of my/our nominee to be printed in the statement of holding or statement of account, provided to me/us by the AMC as follows (Optional) - Name of the Nominee(s) and Nomination Status(Yes/No)';
export const NOMINEE_DECLARATION_ERROR = `Please accept the declaration to proceed.`;
export const FORM_INCOMPLETE_ERROR = `Please fill all the details.`;
export const NOMINEE_DECLARATION_OPT_OUT_MESSAGE = `
I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units held in my / our
mutual fund folio and understand the issues involved in non-appointment of nominee(s) and further are aware that
in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite
documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund
folio.`;
export const FATHER_SPOUSE_NOTE_POINTS = [
  'Please be informed the Father/ Spouse details captured above will be updated in your investment account and not in bank account database.',
];
export const BACK = 'Back';
export const TERMS_AND_CONDITION = 'Terms & Conditions';
export const bankAccountAvailable = {
  bankAccountNumbers: [
    {
      label: '918010013335930',
      value: '918010013335930',
    },
    {
      label: '918010013335931',
      value: '918010013335931',
    },
    {
      label: '918010013335932',
      value: '918010013335932',
    },
  ],
  balance: [
    {
      label: '91835930',
      value: '91835930',
    },
    {
      label: '91801001',
      value: '91801001',
    },
    {
      label: '918035932',
      value: '918035932',
    },
  ],
  mobileNumber: '8234567891',
};

// export const TIME_FRAME = [
//   {
//     label: '1',
//     value: '1',
//   },
//   {
//     label: '2',
//     value: '2',
//   },
//   {
//     label: '3',
//     value: '3',
//   },
//   {
//     label: '5',
//     value: '5',
//   },
// ];

export const TIME_FRAME = [
  {
    label: 'less than 3 months',
    value: 'less than 3 months',
  },
  {
    label: '3-9 months',
    value: '3-9 months',
  },
  {
    label: '9-12 months',
    value: '9-12 months',
  },
  {
    label: '12-18 months',
    value: '12-18 months',
  },
  {
    label: '18-24 months',
    value: '18-24 months',
  },
  {
    label: '2-3 years',
    value: '2-3 years',
  },
  {
    label: 'greater than 3 years',
    value: 'greater than 3 years',
  },
];

export const FREQUENCY_VALUE = [
  {
    label: 'Monthly',
    value: 'Monthly',
  },
];

export const SAVE_TAX = 'Save Tax';
export const QUICK_SIP = 'Quick SIP';
export const EXPLORE_FUND = 'Explore Fund';
export const NUDGES_BUTTON_TEXT = (fundCategory: string) => {
  let NUDGE_TEXT_AND_ROUTES = {};
  switch (fundCategory) {
    case 'EQ':
      NUDGE_TEXT_AND_ROUTES = {
        SIP: [
          {
            label: 'Start a SIP',
            route: routes.PLAN_SIP.url,
          },
          {
            label: 'Start a SIP in International Funds',
            route: routes.EXPLORE.url + '/EQ,OTH?subCategory=INF,OFO&isSip=true&from=transaction',
          },
        ],
        LS: [
          {
            label: 'Explore International Funds',
            route: routes.EXPLORE.url + '/EQ,OTH?subCategory=INF,OFO&from=transaction',
          },
          {
            label: 'Explore Index Funds',
            route: routes.EXPLORE.url + '/OTH?subCategory=EIF&from=transaction',
          },
        ],
      };
      break;
    case 'DEBT':
      NUDGE_TEXT_AND_ROUTES = {
        SIP: [
          {
            label: 'Start a SIP',
            route: routes.PLAN_SIP.url,
          },
          {
            label: 'Save Tax with ELSS',
            route:
              routes.EXPLORE.url +
              `/EQ?subCategory=ELS&from=transaction&userFlow=${EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX}`,
            asRoute: routes.EXPLORE.url + '/EQ?subCategory=ELS&from=transaction',
          },
        ],
        LS: [
          {
            label: 'Explore Dynamic Asset Allocation Funds',
            route: routes.EXPLORE.url + '/HYB?subCategory=HDB&from=transaction',
          },
          {
            label: 'Explore Hybrid Funds',
            route: routes.EXPLORE.url + '/Hybrid',
          },
        ],
      };
      break;
    case 'HYB':
      NUDGE_TEXT_AND_ROUTES = {
        SIP: [
          {
            label: 'Start a SIP',
            route: routes.PLAN_SIP.url,
          },
          {
            label: 'Invest in large, mid & small cap funds',
            route: routes.EXPLORE.url + '/EQ?subCategory=EFC&from=transaction',
          },
        ],
        LS: [
          {
            label: 'Invest in large, mid & small cap funds',
            route: routes.EXPLORE.url + '/EQ?subCategory=EFC&from=transaction',
          },
          {
            label: 'Save Tax with ELSS',
            route:
              routes.EXPLORE.url +
              `/EQ?subCategory=ELS&from=transaction&userFlow=${EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX}`,
            asRoute: routes.EXPLORE.url + '/EQ?subCategory=ELS&from=transaction',
          },
        ],
      };
      break;
    case 'LIQUID':
      NUDGE_TEXT_AND_ROUTES = {
        SIP: [
          {
            label: 'Start a SIP',
            route: routes.PLAN_SIP.url,
          },
          {
            label: 'Save Tax with ELSS',
            route:
              routes.EXPLORE.url +
              `/EQ?subCategory=ELS&from=transaction&userFlow=${EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX}`,
            asRoute: routes.EXPLORE.url + '/EQ?subCategory=ELS&from=transaction',
          },
        ],
        LS: [
          {
            label: 'Explore Equity Funds',
            route: routes.EXPLORE.url + '/Equity',
          },
          {
            label: 'Explore Hybrid Funds',
            route: routes.EXPLORE.url + '/Hybrid',
          },
        ],
      };
      break;
    default:
      NUDGE_TEXT_AND_ROUTES = {
        SIP: [
          {
            label: 'Start a SIP',
            route: routes.PLAN_SIP.url,
          },
          {
            label: 'Invest in large, mid & small cap funds',
            route: routes.EXPLORE.url + '/EQ?subCategory=EFC&from=transaction',
          },
        ],
        LS: [
          {
            label: 'Explore Banking and PSU funds',
            route: routes.EXPLORE.url + '/DEBT?subCategory=BSF&from=transaction',
          },
          {
            label: 'Explore Smallcap Funds',
            route: routes.EXPLORE.url + '/EQ?subCategory=ESF&from=transaction',
          },
        ],
      };
      break;
  }
  return NUDGE_TEXT_AND_ROUTES;
};
